import {
  Cascader,
  Col, Form, InputNumber, Row, Select, Input,
} from 'antd';
import { useState } from 'react';

import { object, any } from 'prop-types';
import { last } from 'lodash';
import { CQ_BUSINESS_TYPE } from '@/utils/mappingDict';

export default function CqBusinessForm({ dict, formRef }) {
  const [unit, setUnit] = useState('');

  function handleChange(e, t) {
    if (e) {
      const target = last(t);
      let unitStr = '';
      if (target?.name === '生猪') {
        unitStr = '头';
      } else if (t?.[0]?.name === '畜牧养殖' && target?.name !== '淡水产品') {
        unitStr = '公斤';
      } else {
        unitStr = '亩';
      }
      setUnit(unitStr);
      formRef.setFieldsValue({ plantTypeName: target?.name });
    }
  }

  function handleSelChange(e, t) {
    formRef.setFieldsValue({ businessTypeName: t?.name });
  }

  return (
    <div>
      <Row>
        <Col span={12}>
          <Form.Item name="businessTypeName" label="" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            name="businessType"
            label="经营类型"
            rules={[
              {
                required: true,
                message: '请选择经营类型',
              },
            ]}
          >
            <Select
              placeholder="请选择经营类型"
              options={dict[CQ_BUSINESS_TYPE]}
              fieldNames={{ label: 'name', value: 'val' }}
              onChange={handleSelChange}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="plantArea"
            label="种植/养殖面积"
            rules={[
              {
                required: true,
                message: '请输入种植/养殖面积',
              },
            ]}
          >
            <InputNumber
              placeholder="请输入种植/养殖面积"
              addonAfter="亩"
              style={{ width: '100%' }}
              min={0.1}
              max={99999999}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="plantTypeName" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            name="plantType"
            label="种植/养殖细类"
            rules={[
              {
                required: true,
                message: '请选择种植/养殖细类',
              },
            ]}
          >
            <Cascader
              options={dict?.plantType}
              placeholder="请选择种植/养殖细类"
              fieldNames={{ label: 'name', value: 'id', children: 'children' }}
              onChange={handleChange}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="area"
            label="面积/栏量/主要产品产量"
            rules={[
              {
                required: true,
                message: '请输入面积/栏量/主要产品产量',
              },
            ]}
          >
            <InputNumber
              placeholder="请输入面积/栏量/主要产品产量"
              addonAfter={unit}
              style={{ width: '100%' }}
              min={0.1}
              max={99999999}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}
CqBusinessForm.propTypes = {
  dict: object,
  formRef: any,
};
